export default "__VITE_ASSET__Bd_bzoBs__"